import {
    createExternalRouteRef,
  } from '@backstage/core-plugin-api';
  
  
export const viewTechDocRouteRef = createExternalRouteRef({
    id: 'view-techdoc',
    optional: true,
    params: ['namespace', 'kind', 'name']
});

export const createFromTemplateRouteRef = createExternalRouteRef({
    id: 'create-from-template',
    optional: true,
    params: ['namespace', 'templateName']
  });